import { useEffect, useState } from "react";

type SelectMenuProps = {
    menuPlacement: "auto" | "top" | "bottom";
    menuPosition: "absolute" | "fixed";
    // react-select допускает null / undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    menuPortalTarget?: any;
};

export const useSelectMenuProps = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [menuPortalTarget, setMenuPortalTarget] =
        useState<HTMLElement | null>(null);

    useEffect(() => {
        if (typeof window === "undefined") return;

        setMenuPortalTarget(document.body);

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const selectMenuProps: SelectMenuProps = isMobile
        ? {
            menuPlacement: "auto",
            menuPosition: "absolute",
        }
        : {
            menuPlacement: "top",
            menuPosition: "fixed",
            menuPortalTarget,
        };

    return {
        isMobile,
        menuPortalTarget,
        selectMenuProps,
    };
};
